import { render, staticRenderFns } from "./roleList.vue?vue&type=template&id=307845ec&scoped=true&"
import script from "./roleList.vue?vue&type=script&lang=js&"
export * from "./roleList.vue?vue&type=script&lang=js&"
import style0 from "./roleList.vue?vue&type=style&index=0&id=307845ec&prod&lang=less&scoped=true&"
import style1 from "./roleList.vue?vue&type=style&index=1&id=307845ec&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307845ec",
  null
  
)

export default component.exports